import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { ServService } from './serv.service';
import { ServModel } from '../models/serv.model';
import { InvoiceService } from './invoice.service';
import { InvoiceModel } from '../models/invoice.model';
import { MagasinService } from './magasin.service';

@Injectable()
export class NotPaidService {

    list: any    = [];

    constructor(public apiService: ApiService, private magasinService:MagasinService, public servService:ServService, public invoiceService:InvoiceService) {

    }

    getAll() {
        this.list = [];
        this.apiService.get('notPaid', '').subscribe(res=> {
            res.data.forEach(e=> {
                //this.list = [];
                if (e.type == 'Service'){
                    if (e.magasin == this.magasinService.current)
                        this.list.push(ServModel.j2o(e, this.servService));
                }
                if (e.type == 'Facture'){
                    if (e.magasin == this.magasinService.current) {
                        let invoice             = new InvoiceModel(this.invoiceService);
                        invoice.clientPrivateId = e.client.id;
                        invoice.infoClientName  = e.client.lastName + ' ' + e.client.firstName;
                        invoice.publicId        = e.billPublicId;
                        invoice.privateId       = e.id;
                        invoice.total           = e.price;
                        this.list.push(invoice);
                    }
                }
            });
            this.list.sort(function(a,b){return a.price < b.price});
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/notPaid.service.ts